const reactDevToolsMessage = 'Download the React DevTools';

const shouldSuppress = (args: unknown[]) =>
    args.some((arg) => typeof arg === 'string' && arg.includes(reactDevToolsMessage));

const originalInfo = console.info;
const originalLog = console.log;

console.info = (...args: unknown[]) => {
    if (!shouldSuppress(args)) {
        originalInfo(...args);
    }
};

console.log = (...args: unknown[]) => {
    if (!shouldSuppress(args)) {
        originalLog(...args);
    }
};

export {};
